// extracted by mini-css-extract-plugin
export default {"select":"AsyncTagField_select__Wpr4U"};